module.exports = __webpack_public_path__ + "img/icon-white-33.baa58e8f.svg";